import { createSlice } from "@reduxjs/toolkit";
import { toast } from 'react-toastify';
import { getAllClients, getClientAction, clientChangeStatusAction, insertUpdateClientAction } from "../actions/clientActions";
const INITIAL_STATE = {
    clients: {
        data: {
            records: [],
            totalRecords: 0,
        },
        apiMsg: {
            message: null,
            status: null,
            type: null,
        },
    },
    selectedClient: {
        data: null,
        apiMsg: {
            message: null,
            status: null,
            type: null,
        },
    },


    insertUpdateDetails: {
        data: {},

        apiMsg: {
            message: null,
            status: null,
            type: null,
        },
        newRecord: false
    },
    changeStatusDetails: {
        data: {},

        apiMsg: {
            message: null,
            status: null,
            type: null,
        },
        newRecord: false
    },

}

const clientReducer = createSlice({
    name: "clientData",
    initialState: INITIAL_STATE,
    reducers: {
        RESET(state, action) {
            state = INITIAL_STATE;
        },
        ResetClientDetailsState(state, action) {
            state.selectedClient = INITIAL_STATE.selectedClient;
            state.insertUpdateDetails = INITIAL_STATE.insertUpdateDetails;
        },


    },
    extraReducers: (builder) => {

        //  --------getallclients start--------------------

        builder.addCase(getAllClients.fulfilled, (state, action) => {

            state.clients.data.records = action.payload.data;
            state.clients.apiMsg.status = action.meta.requestStatus;
            state.clients.apiMsg.message = action.payload.message.message;
        });
        builder.addCase(getAllClients.pending, (state, action) => {

            state.clients.data.records = null;
            state.clients.apiMsg.message = action.meta.requestStatus;;
            state.clients.apiMsg.status = action.meta.requestStatus;
        });
        builder.addCase(getAllClients.rejected, (state, action) => {

            state.clients.apiMsg.message = action.error.message;
            state.clients.apiMsg.status = action.meta.requestStatus;
        });

        //  -------- getallclients Action end--------------------

        //   getClient start

        builder.addCase(getClientAction.fulfilled, (state, action) => {
            state.selectedClient.data = action.payload.data
            state.selectedClient.apiMsg.status = action.meta.requestStatus;
            state.selectedClient.apiMsg.message = action.payload.message.message;
        });

        builder.addCase(getClientAction.pending, (state, action) => {
            state.selectedClient.data = null;
            state.selectedClient.apiMsg.message = action.meta.requestStatus;;
            state.selectedClient.apiMsg.status = action.meta.requestStatus;
        });

        builder.addCase(getClientAction.rejected, (state, action) => {
            state.selectedClient.apiMsg.message = action.error.message;
            state.selectedClient.apiMsg.status = action.meta.requestStatus;
        });


        //   getClient end



        // insertUpdateClientAction start

        builder.addCase(
            insertUpdateClientAction.fulfilled,
            (state, action) => {

                state.insertUpdateDetails.data = action.payload.data.data;
                state.insertUpdateDetails.apiMsg.status = action.meta.requestStatus;
                state.insertUpdateDetails.apiMsg.message = action.payload.message.message;



                if (action.payload.newRecord) {


                    if (state.clients.data.records.length) {
                        state.clients.data.records.unshift(action.payload.data.data);
                    }
                    else {
                        state.clients.data.records.push(action.payload.data.data);
                    }
                }
                toast.success(action.payload.message.message, {
                    position: toast.POSITION.BOTTOM_CENTER,
                    toastId: "client-error"
                });

            }
        );
        builder.addCase(
            insertUpdateClientAction.pending,
            (state, action) => {
                state.insertUpdateDetails.apiMsg.status = action.meta.requestStatus;
            }
        );
        builder.addCase(
            insertUpdateClientAction.rejected,
            (state, action) => {

                state.insertUpdateDetails.apiMsg.message = action.error.message;
                state.insertUpdateDetails.apiMsg.status = action.meta.requestStatus;

                toast.error(action.error.message ? action.error.message : "Something went wrong please try again", {
                    position: toast.POSITION.BOTTOM_CENTER,
                    toastId: "dept-error"
                });
            }
        );


        //   insert update client action end

        //------------------------------- changeStatusAction start -------------------------

        builder.addCase(
            clientChangeStatusAction.fulfilled,
            (state, action) => {
                console.log("changeStatusAction", action);

                state.changeStatusDetails.data = action.payload.data;
                state.changeStatusDetails.apiMsg.status = action.meta.requestStatus;
                state.changeStatusDetails.apiMsg.message = action.payload.message.message;

                let updatedRecord = state.clients.data.records.map(x => {
                    if (x.id == action.meta.arg.id) {
                        x.isActive = state.changeStatusDetails.data.isActive;
                        return x;
                    }
                    else {
                        return x;
                    }
                })



                state.clients.data.records = updatedRecord;

                toast.success(action.payload.message.message, {
                    position: toast.POSITION.BOTTOM_CENTER,
                    toastId: "success"
                });

            }
        );
        builder.addCase(
            clientChangeStatusAction.pending,
            (state, action) => {
                state.changeStatusDetails.apiMsg.status = action.meta.requestStatus;
            }
        );
        builder.addCase(
            clientChangeStatusAction.rejected,
            (state, action) => {
                state.changeStatusDetails.apiMsg.message = action.error.message;
                state.changeStatusDetails.apiMsg.status = action.meta.requestStatus;

                toast.error(action.error.message ? action.error.message : "Something went wrong please try again", {
                    position: toast.POSITION.BOTTOM_CENTER,
                    toastId: "error"
                });
            }
        );




    },
});
export const { RESET, ResetClientDetailsState } = clientReducer.actions;
export default clientReducer.reducer;